<template>
  <div class="student-detail">
    <div class="page-header">
      <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
      <h2>学员详情</h2>
      <div class="header-actions">
        <el-button icon="el-icon-edit" @click="handleEdit">编辑</el-button>
        <!-- <el-button icon="el-icon-setting" @click="handleSettings">设置</el-button> -->
      </div>
    </div>

    <el-row :gutter="20" v-loading="loading">
      <!-- 左侧：学员基本信息 -->
      <el-col :span="8">
        <el-card class="student-info-card" shadow="never">
          <div slot="header" class="card-header">
            <span>基本信息</span>
          </div>
          <div class="student-info">
            <div class="info-item">
              <label>学员姓名：</label>
              <span>{{ studentInfo.real_name }}</span>
            </div>
            <div class="info-item">
              <label>手机号：</label>
              <span>{{ studentInfo.mobile }}</span>
            </div>
            <div class="info-item">
              <label>年级：</label>
              <span>{{ studentInfo.grade }}</span>
            </div>
            <div class="info-item">
              <label>性别：</label>
              <span>{{ studentInfo.gender == 1 ? '男' : '女' }}</span>
            </div>
            <!-- <div class="info-item">
              <label>家长姓名：</label>
              <span>{{ studentInfo.parentName || '-' }}</span>
            </div>
            <div class="info-item">
              <label>家长手机：</label>
              <span>{{ studentInfo.parentPhone || '-' }}</span>
            </div> -->
            <div class="info-item">
              <label>状态：</label>
              <el-tag :type="studentInfo.status === 'normal' ? 'success' : 'info'" size="small">
                {{ studentInfo.status === 'normal' ? '在学' : '停课' }}
              </el-tag>
            </div>
            <div class="info-item">
              <label>添加时间：</label>
              <span>{{ studentInfo.createTime }}</span>
            </div>
            <div class="info-item" v-if="studentInfo.remark">
              <label>备注：</label>
              <span>{{ studentInfo.remark }}</span>
            </div>
          </div>
        </el-card>

        <!-- 学习统计卡片 -->
        <el-card class="stats-card" shadow="never">
          <div slot="header" class="card-header">
            <span>学习统计</span>
          </div>
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-value">{{ learningStats.totalWords || 0 }}</div>
              <div class="stat-label">累计学习单词</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ learningStats.masteredWords || 0 }}</div>
              <div class="stat-label">已掌握单词</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ learningStats.studyDays || 0 }}</div>
              <div class="stat-label">学习天数</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ learningStats.avgScore || 0 }}%</div>
              <div class="stat-label">平均测试分数</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧：详细数据 -->
      <el-col :span="16">
        <!-- Tab 切换 -->
        <el-tabs v-model="activeTab" type="border-card">
          <!-- 购买的课程 -->
          <el-tab-pane label="购买的课程" name="courses">
            <course-list-tab v-if="activeTab === 'courses'" :student-id="studentId" />
          </el-tab-pane>

          <!-- 学习数据 -->
          <el-tab-pane label="学习数据" name="learning">
            <learning-data-tab v-if="activeTab === 'learning'" :student-id="studentId" />
          </el-tab-pane>

          <!-- 每日学习 -->
          <el-tab-pane label="每日学习" name="daily">
            <daily-learning-tab v-if="activeTab === 'daily'" :student-id="studentId" />
          </el-tab-pane>

          <!-- 学习时间 -->
          <el-tab-pane label="学习时间" name="time">
            <time-usage-tab v-if="activeTab === 'time'" :student-id="studentId" />
          </el-tab-pane>

          <!-- 测试成绩 -->
          <el-tab-pane label="测试成绩" name="tests">
            <test-scores-tab v-if="activeTab === 'tests'" :student-id="studentId" />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- 编辑对话框 -->
    <student-form-dialog
      :visible.sync="showFormDialog"
      :student-data="studentInfo"
      :is-edit="true"
      @success="handleFormSuccess"
    />

    <!-- 设置对话框 -->
    <student-settings-dialog
      :visible.sync="showSettingsDialog"
      :student-data="studentInfo"
      @success="handleSettingsSuccess"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import StudentFormDialog from '@/components/teacher/StudentFormDialog.vue';
import StudentSettingsDialog from '@/components/teacher/StudentSettingsDialog.vue';
import CourseListTab from '@/components/teacher/tabs/CourseListTab.vue';
import LearningDataTab from '@/components/teacher/tabs/LearningDataTab.vue';
import DailyLearningTab from '@/components/teacher/tabs/DailyLearningTab.vue';
import TimeUsageTab from '@/components/teacher/tabs/TimeUsageTab.vue';
import TestScoresTab from '@/components/teacher/tabs/TestScoresTab.vue';

export default {
  name: 'StudentDetail',
  components: {
    StudentFormDialog,
    StudentSettingsDialog,
    CourseListTab,
    LearningDataTab,
    DailyLearningTab,
    TimeUsageTab,
    TestScoresTab,
  },
  data() {
    return {
      loading: false,
      studentId: null,
      studentInfo: {},
      learningStats: {},
      activeTab: 'courses',
      showFormDialog: false,
      showSettingsDialog: false,
    };
  },
  created() {
    this.studentId = this.$route.params.id;
    this.loadStudentDetail();
  },
  methods: {
    ...mapActions('student', ['fetchStudentDetail']),

    /**
     * 加载学员详情
     */
    async loadStudentDetail() {
      this.loading = true;
      try {
        const result = await this.fetchStudentDetail(this.studentId);
        this.studentInfo = result;
        
        // 如果返回数据中包含 stats,直接使用
        if (result.stats) {
          this.learningStats = result.stats;
        }
      } catch (error) {
        console.error('加载学员详情失败:', error);
        this.$message.error('加载学员详情失败');
      } finally {
        this.loading = false;
      }
    },

    /**
     * 返回
     */
    goBack() {
      this.$router.back();
    },

    /**
     * 编辑学员
     */
    handleEdit() {
      this.showFormDialog = true;
    },

    /**
     * 学员设置
     */
    handleSettings() {
      this.showSettingsDialog = true;
    },

    /**
     * 表单提交成功
     */
    handleFormSuccess() {
      this.showFormDialog = false;
      this.loadStudentDetail();
    },

    /**
     * 设置提交成功
     */
    handleSettingsSuccess() {
      this.showSettingsDialog = false;
      this.loadStudentDetail();
    },
  },
};
</script>

<style scoped>
.student-detail {
  padding: 20px;
  /* max-width: 1400px; */
  max-width: 85%;
  margin: 0 auto;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.page-header h2 {
  flex: 1;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.student-info-card {
  margin-bottom: 20px;
}

.card-header {
  font-weight: 600;
  color: #303133;
}

.student-info {
  padding: 10px 0;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item label {
  width: 100px;
  color: #909399;
  font-size: 14px;
}

.info-item span {
  flex: 1;
  color: #303133;
  font-size: 14px;
}

.stats-card {
  margin-bottom: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 10px 0;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #409eff;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 13px;
  color: #909399;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .student-detail {
    padding: 10px;
  }

  .page-header {
    flex-wrap: wrap;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
